import { useState, useEffect } from "react";
import { Route, Switch } from "react-router";
import { Redirect } from "react-router-dom";
import Name from "./name";
import Kontakt from "./kontakt";
import Anliegen from "./anliegen";
import Einverstaendnis from "./einverstaendnis";
import ScrollToTop from './scrollToTop';
//import Zahlung from "./zahlung";

export default function Index() {
  const [prename, setPrename] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [anliegen, setAnliegen] = useState({});
  const [einverstaendnis, setEinverstaendnis] = useState({});
  const [referrer, setReferrer] = useState();

  const referrer_url = new URLSearchParams(window.location.search).get('ref');
  
  useEffect(() => {
    if (referrer_url)
      fetch('/cust/newticket?ref='+referrer_url)
      .then(response => {
        if (response.status === 201) {
          setReferrer(referrer_url);
          console.log("referrer accepted", referrer);
        } else {
          console.log("referrer not accepted", referrer);
        }
      })
      .catch(console.error);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referrer_url]);

  return (
    <div className="ui container">
      <div id="index">
        <section id="content">
          <ScrollToTop/>
          <Switch>
            <Route exact path='/'>
              <Redirect to='/name'></Redirect>
            </Route>
            <Route path='/name'>
              <Name prename={prename} setPrename={setPrename} surname={surname} setSurname={setSurname} />
            </Route>
            <Route path='/kontakt'>
              <Kontakt
                prename={prename}
                email={email}
                setEmail={setEmail}
              />
            </Route>
            <Route path='/anliegen'>
              <Anliegen anliegen={anliegen} setAnliegen={setAnliegen} />
            </Route>
            <Route path='/einverstaendnis'>
              <Einverstaendnis
                anliegen={anliegen}
                prename={prename}
                surname={surname}
                email={email}
                einverstaendnis={einverstaendnis}
                setEinverstaendnis={setEinverstaendnis}
              />
            </Route>
          </Switch>
        </section>
      </div>
    </div>
  );
}
